import { useEffect, useState } from 'react';

import Image from 'react-bootstrap/Image';

import Menu from '../../components/MenuProducaoSustentavel';

import header from '../../images/ps-header.png'

import constantes from '../../helpers/constanteHelper';

function Sobre() {
    const [width, setWidth] = useState(window.innerWidth);


    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', observarMudancaWidth);

        // Scroll para o topo da página para melhor visualização no mobile ou em resoluções menores
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    return (
        <>
            <div style={{ minHeight: '100vh', background: constantes.CORES.VERDE_PRODUCAO_SUSTENTAVEL }} className='text-center d-flex flex-column align-items-center'>
                <Menu opcaoSelecionada={'sobre'} />
                <div className='animate__animated animate__fadeIn d-flex flex-column align-items-center'>
                    <div style={{ height: resolucaoMobile ? '20px' : '80px' }}></div>

                    <Image style={{ height: '600px', objectFit: 'contain', padding: '20px' }} src={header} alt='logo' fluid />
                    <h1 className={resolucaoMobile ? 'mb-5' : 'mt-5 mb-5'} style={{ color: constantes.CORES.BRANCO_PADRAO, fontWeight: 700 }}>Certificação de Produção Sustentável</h1>

                    <span className='mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: '20px', whiteSpace: 'pre-line', textAlign: resolucaoMobile ? 'justify' : 'center' }}>
                        O programa de certificação “Produção Sustentável” contempla o diagnóstico de sustentabilidade da produção de proteínas de origem animal, a mensuração das emissões associadas à etapa produtiva e o compromisso com a melhoria contínua quanto às questões de sustentabilidade.<br /><br />
                        Todo o processo de certificação é embasado em auditoria de terceira parte, na qual são avaliadas informações utilizadas para cálculo de indicadores e práticas adotadas nas propriedades rurais. Desta forma, são geradas informações sobre o nível de engajamento em práticas sustentáveis e aspectos relevantes para as emissões de GEE na propriedade, permitindo o direcionamento de estratégias para mitigação e manutenção do compromisso com a sustentabilidade.<br /><br />
                    </span>

                </div>
            </div>
        </>
    );
}

export default Sobre;
